export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.5 13a1 1 0 01.858.485l4.5 7.5A1.002 1.002 0 0120 22.5h-9a1.001 1.001 0 01-.858-1.515l4.501-7.5.074-.107a1 1 0 01.784-.378zm-2.734 7.5h5.468L15.5 15.943 12.767 20.5zM10.103 7.505a1 1 0 01.898.995v7a1 1 0 01-1 1H3a1 1 0 01-1-1v-7a1 1 0 011-1h7l.103.005zM4 14.5h5v-5H4v5zM18 1a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};